import Link from "next/link";

import ContactForm from "../Contacts/Contact-Form";

// CONFIGS AND ROUTE
import { ROUTE } from "@/route/app_routes.js";
import { CONFIG } from "@/app_config.js";

const ContactUs = () => {

  return (

    <>

      <main className="rbt-main-wrapper">

        <div className="rbt-contact-hero bg-gradient-11 rbt-section-gapTop">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title text-center mb--40">
                  <span className="subtitle bg-secondary-opacity"> Contact Us </span>
                  <h2 className="title"> Questions About a Course, <br /> or Just Want to Say Hi? </h2>
                  <p className="description has-medium-font-size mt--10">
                    {"Whether it's a question about a lesson, a bug you've spotted, or an idea for a new course — a real person on our team reads every message."}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="rbt-contact-main">
          <div className="container">
            <div className="rbt-contact-card">

              <div className="rbt-contact-card__info">
                <span className="rbt-contact-card__eyebrow">Get in touch</span>
                <h3>We&apos;d love to hear from you</h3>
                <p>Send a message and we&apos;ll get back to you as soon as we can.</p>

                <ul className="rbt-contact-card__list">
                  <li>
                    <span className="rbt-contact-card__icon"><i className="feather-mail"></i></span>
                    <div>
                      <strong>Email us</strong>
                      <Link href={`mailto:${CONFIG.EMAIL_1}`}>{CONFIG.EMAIL_1}</Link>
                    </div>
                  </li>
                  <li>
                    <span className="rbt-contact-card__icon"><i className="feather-clock"></i></span>
                    <div>
                      <strong>Response time</strong>
                      <span>Within 1–2 business days</span>
                    </div>
                  </li>
                  <li>
                    <span className="rbt-contact-card__icon"><i className="feather-help-circle"></i></span>
                    <div>
                      <strong>Quick answers</strong>
                      <Link href={ROUTE.faq}>Check our FAQ page</Link>
                    </div>
                  </li>
                  <li>
                    <span className="rbt-contact-card__icon"><i className="feather-globe"></i></span>
                    <div>
                      <strong>Fully remote</strong>
                      <span>Online-only, every course free, wherever you are</span>
                    </div>
                  </li>
                </ul>

                <div className="rbt-contact-card__socials">
                  <Link href={ROUTE.FACEBOOK} aria-label="Facebook"><i className="feather-facebook"></i></Link>
                  <Link href={ROUTE.TWITTER} aria-label="Twitter"><i className="feather-twitter"></i></Link>
                  <Link href={ROUTE.LINKEDIN} aria-label="LinkedIn"><i className="feather-linkedin"></i></Link>
                  <Link href={ROUTE.INSTAGRAM} aria-label="Instagram"><i className="feather-instagram"></i></Link>
                  <Link href={ROUTE.YOUTUBE} aria-label="YouTube"><i className="feather-youtube"></i></Link>
                </div>
              </div>

              <div className="rbt-contact-card__form">
                <ContactForm />
              </div>

            </div>
          </div>
        </div>

        <div className="rbt-call-to-action-area rbt-section-gap bg-color-secondary-alt">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="rbt-cta-6 text-center">
                  <div className="content">
                    <h1 className="title"> {"Ready to start"}
                      <br /> learning for free? </h1>
                    <p>No cost, no catch &mdash; just real courses.</p>
                    <div className="rbt-button-group justify-content-center">
                      <Link className="rbt-btn btn-gradient" href={ROUTE.register}> Join for Free </Link>
                      <Link className="rbt-btn btn-border" href={ROUTE.course}> Browse Courses </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </main>

    </>
  );

};



export default ContactUs;
